import {css} from 'lit';
import {customElement} from 'lit/decorators.js';
import {of} from 'rxjs';

import {FilterView} from './filter-view';
import {Filter, Filterable} from './interfaces/filterable';
import {ri} from './runner-idle';

@customElement('ri-resources')
export class Resources extends FilterView {
  // #region Properties (13)

  public static override styles = [
    ...FilterView.styles,
    css`
      .top-container {
        height: auto;
      }
      .bottom-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        overflow-y: auto;
      }
      .bottom-container * {
        margin: 4px 4px 0px;
        width: calc(100% - 8px);
      }
    `,
  ];

  // public override filterablesBeforeShowFilter = 10;
  public override helpContent = `
    This is the Resources panel.
    <br>It shows all the Resources you have in your inventory.
    <br>Hover/click on a Resource to toggle its details (configure in ⚙ Settings)`;
  public override id = 'resources';
  public override isIntersection = true;
  public override isPackery = false;
  public override name = 'Resources';
  public override possibleFilters = new Set([
    {name: 'body', displayName: 'Body'},
    {name: 'mind', displayName: 'Mind'},
    {name: 'train', displayName: 'Training'},
    {name: 'meditate', displayName: 'Meditation'},
    {name: 'food', displayName: 'Food'},
    {name: 'special', displayName: 'Special'},
    {name: 'experience', displayName: 'XP'},
    {
      name: 'hiddenByPlayer',
      displayName: 'Hidden',
      condition: (a: Filterable) => a.hiddenByPlayer,
    },
  ]) as Set<Filter>;
  public override replacementEntryTag = 'ri-resource';
  public override subtitle = 'Only some is never enough.';

  // #endregion Properties (13)

  // #region Public Methods (1)
  constructor() {
    super();
    this.filterables$ = of(Object.values(ri.resources));
    this.unlock$ = ri.landmarks.resources.visited$;
  }

  override setup() {
    super.setup();
    this.settings = ri.settings.resources;
  }

  // public override firstUpdated(changedProperties) {
  //   super.firstUpdated(changedProperties);
  //   // HACK What the fuck dude, what's happening in between that requires this?
  //   setTimeout(() => (this.filterables = Object.values(ri.resources)), 1000);
  // }

  // #endregion Public Methods (1)
}
